import { useState } from "react";
import { faq_constants } from "./constants";
import { Link } from "react-router-dom";

export default function FAQ() {
  const [openItems, setOpenItems] = useState([null]);

  const toggleItem = (index) => {
    setOpenItems((prev) =>
      prev.includes(index)
        ? prev.filter((item) => item !== index)
        : [...prev, index]
    );
  };

  return (
    <section className="py-5 md:py-[64px] bg-[#EDF8FF]" id="faq">
      <div className="container px-3">
        <div className="grid sm:grid-cols-2 gap-12 items-center">
          <div className="flex flex-col justify-center items-center md:justify-start md:items-start gap-5">
            <div className="space-y-3">
              <span className="text-primary_alt font-bold uppercase hidden md:block">
                FAQ
              </span>
              <h2 className="text-[22px] lg:text-[36px] font-bold text-black text-center md:text-left">
                {faq_constants.title}
              </h2>
            </div>
            <p className="text-[#222] text-center md:text-left md:text-xl">
              {faq_constants.description}
            </p>
            <Link
              to="/signup"
              className="rounded-lg bg-primary_alt border border-[#B6E4FF] py-2.5 px-4 text-white w-max"
            >
              Contact Us
            </Link>
          </div>

          <div>
            {faq_constants.faqData.map((faq, index) => (
              <div key={index} className="overflow-hidden">
                <button
                  onClick={() => toggleItem(index)}
                  className="w-full  py-4 flex items-center justify-between"
                >
                  <span className="text-black font-bold text-left md:text-lg pr-4">
                    {faq.question}
                  </span>
                  <div
                    className={`flex-shrink-0 transition-transform duration-200 ${
                      openItems.includes(index) ? "rotate-180" : ""
                    }`}
                  >
                    {openItems.includes(index) ? (
                      <faq_constants.MinusIcon className="w-6 h-6" />
                    ) : (
                      <faq_constants.PlusIcon className="w-6 h-6" />
                    )}
                  </div>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    openItems.includes(index)
                      ? "max-h-96 opacity-100"
                      : "max-h-0 opacity-0"
                  }`}
                >
                  <div
                    className="pb-4 text-sm md:text-base text-black"
                    dangerouslySetInnerHTML={{ __html: faq.answer }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
